import { lazy } from "react";
import { createFileRoute } from "@tanstack/react-router";

const ManualTaxInvoicesListPage = lazy(
  () => import("@/pages/tools.manual-tax-invoices.index.page"),
);

export const Route = createFileRoute("/tools/manual-tax-invoices/")({
  component: ManualTaxInvoicesListPage,
});
